module.exports = __webpack_public_path__ + "images/brand-performance-button-d7ccadce.svg";